import { render, staticRenderFns } from "./ReportDownloader.vue?vue&type=template&id=da310daa&"
import script from "./ReportDownloader.vue?vue&type=script&lang=ts&"
export * from "./ReportDownloader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports